export default __webpack_public_path__ + "static/media/Home_Header@2x.0bcbec2d.jpg";